import {
  completeForLocking,
  isProgrammeComplete,
} from '../../functions/shared/programmeSelection';

const comparable = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (value instanceof Date) return value.toISOString();
  if (typeof value?.toDate === 'function') {
    try {
      return value.toDate().toISOString();
    } catch {
      return '';
    }
  }
  return String(value);
};

const sequenceSort = (a, b) => {
  const byIndex = (Number(a?.sequenceIndex) || 0) - (Number(b?.sequenceIndex) || 0);
  if (byIndex !== 0) return byIndex;
  const byDate = comparable(a?.plannedStartAt || a?.createdAt)
    .localeCompare(comparable(b?.plannedStartAt || b?.createdAt));
  if (byDate !== 0) return byDate;
  return String(a?.id || '').localeCompare(String(b?.id || ''));
};

const groupSort = (a, b) => {
  const byAnchor = (a.anchor || '').localeCompare(b.anchor || '');
  if (byAnchor !== 0) return byAnchor;
  if (a.orderRef && b.orderRef && a.orderRef === b.orderRef && a.priority !== b.priority) {
    return a.priority - b.priority;
  }
  const byOrder = String(a.orderRef || '').localeCompare(String(b.orderRef || ''));
  if (byOrder !== 0) return byOrder;
  return String(a.id || '').localeCompare(String(b.id || ''));
};

export function computeProgrammeLocks(programmes = []) {
  const rows = (Array.isArray(programmes) ? programmes : [])
    .filter((programme) => programme?.id && !programme.consulenzeOnly);
  const groups = new Map();

  rows.forEach((programme) => {
    const groupId = programme.sequenceGroupId || programme.id;
    const current = groups.get(groupId) || [];
    current.push(programme);
    groups.set(groupId, current);
  });

  const sequentialLocks = {};
  groups.forEach((groupRows) => {
    const sorted = [...groupRows].sort(sequenceSort);
    const gatingActive = sorted.length > 1 || Number(sorted[0]?.sequenceTotal) > 1;
    let blockFollowing = false;

    sorted.forEach((programme) => {
      const override = programme.sequenceUnlockOverride === true;
      sequentialLocks[programme.id] = gatingActive && blockFollowing && !override;
      if (gatingActive) blockFollowing = !completeForLocking(programme);
    });
  });

  const orderedGroups = [...groups.entries()].map(([id, groupRows]) => {
    const sorted = [...groupRows].sort(sequenceSort);
    const first = sorted[0] || {};
    const anchors = sorted
      .map((programme) => comparable(
        programme.orderSequenceAnchor || programme.plannedStartAt || programme.createdAt
      ))
      .filter(Boolean)
      .sort();
    return {
      id,
      rows: sorted,
      anchor: anchors[0] || '',
      orderRef: first.orderRef || '',
      priority: Number.isFinite(Number(first.orderSequencePriority))
        ? Number(first.orderSequencePriority)
        : Number.MAX_SAFE_INTEGER,
    };
  }).sort(groupSort);

  const previousLocks = {};
  let previousGroupIncomplete = false;
  orderedGroups.forEach((group) => {
    group.rows.forEach((programme) => {
      previousLocks[programme.id] = previousGroupIncomplete
        && programme.sequenceUnlockOverride !== true;
    });
    const groupComplete = group.rows.every(
      (programme) => programme.sequenceUnlockOverride === true || completeForLocking(programme)
    );
    if (!groupComplete) previousGroupIncomplete = true;
  });

  return { sequentialLocks, previousLocks, orderedGroups };
}

export { isProgrammeComplete };
